import { render, staticRenderFns } from "./AddressFloor.vue?vue&type=template&id=136e2e9a&"
import script from "./AddressFloor.vue?vue&type=script&lang=ts&"
export * from "./AddressFloor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports